import React, { ChangeEvent, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { add_user, get_tenant_setting, add_tenant_user, verify_user } from '../api/usersApi';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { addUser, allLocationType } from '../../../modules/accounts/components/settings/SettingsModel';
import secureLocalStorage from 'react-secure-storage';
import { filter_role_by_status } from '../roles/api/rolesApi';
import { validateImage } from '../../../helper-functions/ImageValidation';
import { get_all_active_categories } from '../../categories/api/categoriesApi';
import { get_all_active_subcategories } from '../../subcategories/api/subcategoriesApi';
import { get_all_meeting_locations, get_all_virtual_platforms } from '../../locations/api/locationsApi';
import Select from 'react-select';
import { getCountries } from '../../../helper-functions/Countries';
import { useGeneralSettings } from '../../../contexts/GeneralSettingsContext';
interface Category {
  id: number;
  title: string;
};
interface Subcategory {
  id: number;
  title: string;
  categories_id: number | undefined;
  categories_title: string | undefined;
};

type User = {
  id: number;
  department_id: string;
  department_name: string | undefined;
  title: string | undefined;
  firstname: string | undefined;
  middlename: string | undefined;
  lastname: string | undefined;
  telephone: string | undefined;
  email: string | undefined;
  mobile: string | undefined;
  picture: string | undefined;
  role: string | undefined;
  password_confirmation: string | undefined;
  status: number | undefined;
  created_at: string;
  deleted_at: string;
  updated_at: string;
  // address_line_1: string,
  address_line_2: string,
  town: string,
  city: string,
  postal_code: string,
  country: string,
  other_information: string,
  // password: string,
  // confirm_password: string,
  appointment_rate: string,
  sub_categories: { value: string }[]
  people_locations: { value: string }[]
  people_platforms: { value: string }[]
  can_get_appointments: number
};
const initialValues: addUser = {
  title: "",
  address: "",
  firstname: "",
  middlename: "",
  lastname: "",
  telephone: "",
  email: "",
  // password: "",
  mobile: "",
  picture: "",
  role: "",
  status: 1,
  // address_line_1: "",
  address_line_2: "",
  town: "",
  city: "",
  postal_code: "",
  country: "",
  other_information: "",
  // confirm_password: "",
  appointment_rate: "",
  sub_categories: [],
  people_locations: [],
  people_platforms: [],
  can_get_appointments: 0,
};
interface userRoleType {
  id: number;
  name: string;
};
interface Department {
  id: number;
  name: string;
};
const numberRegex = /^[+0-9]+$/;
const userSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  firstname: Yup.string().required('First Name is required'),
  lastname: Yup.string().required('Last Name is required'),
  email: Yup.string()
    .required('Email is required')
    .matches(/^[A-Za-z0-9._%+-]+@([A-Za-z0-9.-]+\.[A-Za-z]{2,4})$/, 'Invalid email address'),
  mobile: Yup.string()
    .required('Mobile Number is required')
    .matches(numberRegex, 'Mobile Number must be in numeric value'),
  role: Yup.string().required('Role is required'),

  telephone: Yup.string().matches(numberRegex, 'Telephone number must be in numeric value'),

  town: Yup.string().when('can_get_appointments', {
    is: 1,
    then: (schema) => schema.required('Town is required'),
  }),
  city: Yup.string().when('can_get_appointments', {
    is: 1,
    then: (schema) => schema.required('City is required'),
  }),
  postal_code: Yup.string().when('can_get_appointments', {
    is: 1,
    then: (schema) => schema.required('Postal Code is required'),
  }),
  country: Yup.string().when('can_get_appointments', {
    is: 1,
    then: (schema) => schema.required('Country is required'),
  }),
  appointment_rate: Yup.string().when('can_get_appointments', {
    is: 1,
    then: (schema) => schema
      .required("Appointment Rate is required")
      .matches(/^\d+(\.\d{1,2})?$/, "Rate must be a valid number with up to 2 decimal places"),
  }),

  // Bonus: Subcategory ki validation
  sub_categories: Yup.array().when('can_get_appointments', {
    is: 1,
    then: (schema) => schema.min(1, 'At least one subcategory is required'),
  }),
});
function AddUser() {
  const { getSettingValue } = useGeneralSettings();
  const userDateFormat = getSettingValue('date_format') || 'dd-mm-yyyy';
  const userTimeFormat = getSettingValue('time_format') || '12hr';
  const userTimeZone = getSettingValue('time_zone') || 'UTC';
  

  const [selectedUser, setSelectedUser] = useState<User | null>();
  const [loading, setLoading] = useState(false);
  const [department, setDepartment] = useState<Department[]>([]);
  const [roleType, setRoleType] = useState<userRoleType[]>([]);
  const [organisationApplicationData, setOrganisationApplicationData] = useState<{
    application_id: number;
    organization_id: number;
  }>({
    application_id: 0,
    organization_id: 0,
  });
  const [userPicture, setUserPicture] = useState<File | null>(null);
  const navigate = useNavigate();
  const { data } = useQuery(
    'filter_role_by_status',
    () => filter_role_by_status(1),
    { refetchOnWindowFocus: false }
  );
  const [categories, setCategories] = useState<Category[]>([])
  const [subcategories, setSubcategories] = useState<Subcategory[]>([])
  const [locations, setLocations] = useState<allLocationType[]>([])
  const [platforms, setPlatforms] = useState<allLocationType[]>([])
  const [selectedId, setSelectedid] = useState<Number>()
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [subcategoryValidation, setSubcategoryValidation] = useState("");
  const [selectedCategories, setSelectedCategories] = useState<Category[]>([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState<Subcategory[]>([]);
  // const [can_get_appointments, set_can_get_appointments] = useState(0);
  //getting categories data
  const { data: categoryData } = useQuery('categories', get_all_active_categories, { refetchOnWindowFocus: false })
  useEffect(() => {
    if (categoryData) {
      setCategories(categoryData.data as Category[])
    }
  }, [categoryData]);
  const { data: subcategoryData } = useQuery('get_all_active_subcategories', get_all_active_subcategories, { refetchOnWindowFocus: false });

  useEffect(() => {
    if (subcategoryData) {
      // Set subcategories based on the API response for the selected category
      if (subcategoryData) {
        setSubcategories(subcategoryData.data); // Reset with latest data
      }
    } else {
      // Clear subcategories if no category is selected
      setSubcategories([]);
    }
  }, [subcategoryData]);
  const { data: platformData } = useQuery('platforms', get_all_virtual_platforms, { refetchOnWindowFocus: false })
  useEffect(() => {
    if (platformData) {
      setPlatforms(platformData.data as allLocationType[])
    }
  }, [platformData])
  // getting all locations
  const { data: locationData } = useQuery('locations', get_all_meeting_locations, { refetchOnWindowFocus: false })
  useEffect(() => {
    if (locationData) {
      setLocations(locationData.data as allLocationType[])
    }
  }, [locationData])
  // function to change the subcategories list
  // const handleCategoryChage = (selectedOptions) => {
  //   selectedOptions.map((option) => {
  //     setSelectedid(option?.value)
  //   })
  // }
  // Function to handle category change
  const handleCategoryChange = (selectedOptions) => {
    const updatedCategories = selectedOptions.map((option) => ({
      id: option.value,
      title: option.label,
    }));
    setSelectedCategories(updatedCategories);

    // Get all subcategories for the selected categories
    const allSubcategories = subcategories.filter((subcategory) =>
      updatedCategories.some((category) => category.id === subcategory.categories_id)
    );

    // Preserve deselected subcategories
    const preservedSelectedSubcategories = selectedSubcategories.filter((selectedSubcategory) =>
      allSubcategories.some((subcategory) => subcategory.id === selectedSubcategory.id)
    );

    setSelectedSubcategories(preservedSelectedSubcategories);
  };
  // Function to handle subcategory selection
  const handleSubcategoryChange = (selectedOptions) => {
    setSelectedSubcategories(selectedOptions.map((option) => ({
      id: option.value,
      title: option.label,
      category_id: option.category_id,
    })));
  };
  useEffect(() => {
    if (data && Array.isArray(data.data)) {
      setRoleType(data.data as userRoleType[]);
    } else {
      setRoleType([]); // fallback to empty array to avoid `.map()` error
    }
  }, [data]);
  useEffect(() => {
    const fetchTenantSetting = async () => {
      try {
        const result = await get_tenant_setting();
        setOrganisationApplicationData(result);
      } catch (error) {
        console.error('Error fetching tenant settings:', error);
      }
    };

    fetchTenantSetting();
  }, []);
  // const { data: departmentData } = useQuery('department', get_active_department, {refetchOnWindowFocus: false});
  // useEffect(() => {
  //   if (departmentData) {
  //     setDepartment(departmentData.data as Department[]);
  //   };
  // }, [departmentData]);
  const formik = useFormik<addUser>({
    initialValues,
    validationSchema: userSchema,
    onSubmit: async (values) => {
      setLoading(true);

      // Extract `frontend_domain` from window location
      const currentURL = window.location.hostname; // 'abc.com' will be extracted
      const frontendDomain = currentURL.replace(/^www\./, ''); // Remove 'www.' if it exists

      // Get `backend_domain` from secureLocalStorage and remove `http://` or `https://`
      const backendDomain = (typeof secureLocalStorage.getItem('baseURL') === 'string'
        ? secureLocalStorage.getItem('baseURL') as string
        : ''
      )?.replace(/^(https?:\/\/)/, '');

      // Get `organization_id` and `application_id` from organisationApplicationData state
      const { organization_id, application_id } = organisationApplicationData;
      // Create data for `add_tenant_user` API
      const tenantUserData: any = {
        first_name: values.firstname,
        middle_name: values.middlename,
        last_name: values.lastname,
        email: values.email,
        mobile_no: values.mobile,
        organization_id,
        application_id,
        frontend_domain: frontendDomain,
        domain: backendDomain,
        profile_picture: userPicture ? userPicture : null
      };
      // Create a FormData object
      const formData: any = new FormData();
      formData.append('address', values.address)
      formData.append('title', values.title)
      formData.append('firstname', values.firstname)
      formData.append('middlename', values.middlename)
      formData.append('lastname', values.lastname)
      formData.append('telephone', values.telephone)
      formData.append('email', values.email)
      formData.append('mobile', values.mobile)
      formData.append('role', values.role)
      formData.append('status', values.status)
      // formData.append('address_line_1', values.address_line_1)
      formData.append('address_line_2', values.address_line_2)
      formData.append('town', values.town)
      formData.append('city', values.city)
      formData.append('postal_code', values.postal_code)
      formData.append('country', values.country)
      // formData.append('picture', values.picture)
      formData.append('can_get_appointments', values.can_get_appointments)
      formData.append('other_information', values.other_information)
      // formData.append('password', values.password)
      // formData.append('confirm_password', values.confirm_password)
      formData.append('appointment_rate', values.appointment_rate)

      // sub_categories array ko JSON.stringify karke bhejna
      // sub_categories ko loop mein append karna
      // selectedSubcategories?.forEach((subcategory, index) => {
      //   formData.append(`sub_categories[${index}][sub_category_id]`, subcategory.id)
      // })
      // Map sub_categories in the form of requirements.
      values.sub_categories?.forEach((subcategory, index) => {
        formData.append(`sub_categories[${index}][sub_category_id]`, subcategory.value);
      });

      // people_locations ko loop mein append karna
      values.people_locations?.forEach((location, index) => {
        formData.append(`people_locations[${index}][location_id]`, location.value)
      })

      // people_platforms ko loop mein append karna
      values.people_platforms?.forEach((platform, index) => {
        formData.append(`people_platforms[${index}][location_id]`, platform.value)
      })

      // formData.append('status', values.status);
      if (userPicture) {
        formData.append('picture', userPicture);
      };
      try {
        // Call the first API (add_user)
        const userResult = await add_user(formData);
        toast.success(userResult.message, {
          position: 'top-right',
          autoClose: 3000,
        });

        // Call the second API (add_tenant_user) after the first one succeeds
        const tenantResult = await add_tenant_user(tenantUserData);
        // toast.success(tenantResult.message, {
        //   position: 'top-right',
        //   autoClose: 3000,
        // });

        // Navigate to the user list
        navigate('/users/users-list');
      } catch (error: any) {
        if (error.response) {
          const errorMessage = error.response.data.message;
          toast.error(errorMessage, {
            position: 'top-right',
            autoClose: 2000,
          });
        }
      } finally {
        setLoading(false);
      }
    },
  });
  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    logoType: string,
    MAX_FILE_SIZE: number,
    ALLOWED_TYPES: string[],
    MAX_DIMENSIONS: { [key: string]: { width: number; height: number } }
  ) => {
    const newFile = e.target.files?.[0];
    if (newFile) {
      // Call the validation function
      validateImage(
        newFile,
        logoType,
        (validFileUrl) => {
          // If valid, update the state with the image URL
          if (logoType === 'picture') {
            setUserPicture(newFile);
          }
        },
        MAX_FILE_SIZE, // File size limit in MB
        ALLOWED_TYPES, // Allowed file types
        MAX_DIMENSIONS // Maximum dimensions per logo type
      );
    }
  };
  function verifyUser(): void {
    const userEmailInput = (document.getElementById('user_email_input') as HTMLInputElement)?.value;
    fetchUserData(userEmailInput)
  }
  const fetchUserData = async (email) => {
    const userEmailInput = (document.getElementById('user_email_input') as HTMLInputElement)?.value;
    try {
      // Call the first API (add_user)
      const response = await verify_user(email);
      setSelectedUser(response.data)
      formik.setFieldValue('firstname', response.data?.first_name || '');
      formik.setFieldValue('email', response.data?.email || userEmailInput);
      formik.setFieldValue('middlename', response.data?.middle_name || '');
      formik.setFieldValue('lastname', response.data?.last_name || '');
      formik.setFieldValue('mobile', response.data?.mobile_no || '');
      toast.success(response.message, {
        position: 'top-right',
        autoClose: 3000,
      });

    } catch (error: any) {
      if (error.response) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 2000,
        });
        formik.setFieldValue('firstname', '');
        // formik.setFieldValue('email', '');
        formik.setFieldValue('middlename', '');
        formik.setFieldValue('lastname', '');
        formik.setFieldValue('mobile', '');
      }
    } finally {
      // setLoading(false);
    }
  };

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Add User</h3>
          </div>
        </div>
        <div id='kt_account_profile_details' className='collapse show'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>Email</label>
              <div className='col-lg-6 fv-row'>
                <input
                  type='email'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Email'
                  id='user_email_input'
                  {...formik.getFieldProps('email')}
                  onChange={formik.handleChange}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.email}</div>
                  </div>
                )}
              </div>
              <div className='col-lg-2 fv-row'>
                <button
                  data-toggle='tooltip'
                  data-placement='bottom'
                  title='Verify User'
                  type='button'
                  className='btn btn-primary'
                  onClick={() => verifyUser()}
                >
                  Verify User
                </button>
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Role</span>
              </label>
              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg fw-bold'
                  {...formik.getFieldProps('role')}
                >
                  <option value=''>Select a Role...</option>
                  {Array.isArray(roleType) && roleType.length > 0 ? (
                    roleType.map((role) => (
                      <option key={role.id} value={role.name}>
                        {role.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No role available</option>
                  )}
                </select>
                {formik.touched.role && formik.errors.role && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.role}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Title</span>
              </label>
              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg fw-bold'
                  {...formik.getFieldProps('title')}
                  value={formik.values.title}
                  onChange={(e) => formik.setFieldValue('title', e.target.value)}
                  onBlur={formik.handleBlur}
                >
                  <option value=''>Select a Title...</option>
                  <option value='Mr.'>Mr.</option>
                  <option value='Mrs.'>Mrs.</option>
                  <option value='Ms.'>Ms.</option>
                </select>
                {formik.touched.title && formik.errors.title && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.title}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>First Name</label>
              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='First Name'
                  {...formik.getFieldProps('firstname')}
                  onChange={formik.handleChange}
                />
                {formik.touched.firstname && formik.errors.firstname && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.firstname}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Middle Name</label>
              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Middle Name'
                  {...formik.getFieldProps('middlename')}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>Last Name</label>
              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Last Name'
                  {...formik.getFieldProps('lastname')}
                  onChange={formik.handleChange}
                />
                {formik.touched.lastname && formik.errors.lastname && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.lastname}</div>
                  </div>
                )}
              </div>
            </div>
            {/* Validation added */}
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                Enable Appointments
              </label>
              <div className='col-lg-8 fv-row d-flex align-items-center gap-4'>
                <div className="form-check form-switch form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableAppointments"
                    checked={formik.values.can_get_appointments === 1}
                    onChange={(e) => {
                      const isEnabled = e.target.checked;
                      formik.setFieldValue('can_get_appointments', isEnabled ? 1 : 0);
                      if (!isEnabled) {
                        formik.setFieldValue('town', '');
                        formik.setFieldValue('city', '');
                        formik.setFieldValue('postal_code', '');
                        formik.setFieldValue('country', '');
                        formik.setFieldValue('appointment_rate', '');
                        formik.setFieldValue('sub_categories', []);
                        setSelectedSubcategories([]);


                        formik.setFieldError('town', undefined);
                        formik.setFieldError('city', undefined);
                        formik.setFieldError('postal_code', undefined);
                        formik.setFieldError('country', undefined);
                        formik.setFieldError('appointment_rate', undefined);
                        formik.setFieldError('sub_categories', undefined);
                      }
                    }}
                  />
                  <label className="form-check-label" htmlFor="enableAppointments">
                    {formik.values.can_get_appointments === 1 ? 'Enabled' : 'Disabled'}
                  </label>
                </div>
              </div>
            </div>
            {/* <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                Enable Appointments
              </label>
              <div className='col-lg-8 fv-row d-flex align-items-center gap-4'>
                <div className="form-check form-switch form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableAppointments"
                    checked={formik.values.can_get_appointments === 1}
                    onChange={(e) => {
                      formik.setFieldValue('can_get_appointments', e.target.checked ? 1 : 0);
                    }}
                  />
                  <label className="form-check-label" htmlFor="enableAppointments">
                    {formik.values.can_get_appointments === 1 ? 'Enabled' : 'Disabled'}
                  </label>
                </div>
              </div>
            </div> */}
            {formik.values.can_get_appointments === 1 && (
              <>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Category</span>
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      isMulti
                      placeholder="Select Categories..."
                      options={Array.isArray(categories) ? categories.map((category) => ({
                        value: category.id,
                        label: category.title,
                      })) : []}
                      className="basic-multi-select form-select-lg p-2 bg-light text-black"
                      classNamePrefix="select border-light fw-bold"
                      onChange={handleCategoryChange}
                    />

                  </div>
                </div>
                {/* <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Subcategory</span>
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      isMulti
                      placeholder="Select Subcategories..."
                      options={subcategories
                        .filter((subcategory) =>
                          selectedCategories.some((category) => category.id === subcategory.categories_id)
                        )
                        .map((subcategory) => ({
                          value: subcategory.id,
                          label: subcategory.title,
                          category_id: subcategory.categories_id,
                        }))}
                      value={selectedSubcategories.map((subcategory) => ({
                        value: subcategory.id,
                        label: subcategory.title,
                        category_id: subcategory.categories_id,
                      }))}
                      className="basic-multi-select form-select-lg p-2 bg-light text-black"
                      classNamePrefix="select border-light fw-bold"
                      onChange={handleSubcategoryChange}
                    />
                    {subcategoryValidation && (
                      <div className='text-danger'>{subcategoryValidation}</div>
                    )}
                  </div>
                </div> */}
                {/* changes in jsx */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Subcategory</span>
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      isMulti
                      placeholder="Select Subcategories..."
                      options={
                        subcategories
                          .filter((subcategory) =>
                            selectedCategories.some((category) => category.id === subcategory.categories_id)
                          )
                          .map((subcategory) => ({
                            // FIX 1: 'value' ko hamesha string banayein
                            value: String(subcategory.id),
                            label: subcategory.title || '', // Ek fallback bhi dein
                          }))
                      }
                      value={formik.values.sub_categories}
                      className="basic-multi-select form-select-lg p-2 bg-light text-black"
                      classNamePrefix="select border-light fw-bold"
                      onChange={(selectedOptions) => {
                        formik.setFieldValue('sub_categories', selectedOptions || []);
                      }}
                      onBlur={() => {
                        // 'touched' state ko set karein jab user dropdown se bahar click kare
                        formik.setFieldTouched('sub_categories', true);
                      }}
                    />

                    {/* FIX 2: Error ko display karne se pehle check karein ki woh string hai */}
                    {formik.touched.sub_categories && typeof formik.errors.sub_categories === 'string' && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.sub_categories}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6 required'>Town</label>
                  <div className='col-lg-8 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Town'
                      {...formik.getFieldProps('town')}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.town && formik.errors.town && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.town}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6 required'>City</label>
                  <div className='col-lg-8 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='City'
                      {...formik.getFieldProps('city')}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.city && formik.errors.city && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.city}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6 required'>Country </label>
                  <div className='col-lg-8 fv-row'>
                    <select
                      className='form-select form-select-lg form-select-solid'
                      {...formik.getFieldProps('country')}
                      onChange={formik.handleChange}
                    >
                      <option value=''>Select a country...</option>
                      {getCountries().map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                    {formik.touched.country && formik.errors.country && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.country}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6 required'>Postal Code</label>
                  <div className='col-lg-8 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Postal Code'
                      {...formik.getFieldProps('postal_code')}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.postal_code && formik.errors.postal_code && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.postal_code}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Other Information</label>
                  <div className='col-lg-8 fv-row'>
                    <input
                      type='textarea'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Other Information'
                      {...formik.getFieldProps('other_information')}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
                {/* <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>New Password</label>
                  <div className='col-lg-8 fv-row'>
                    <div className='input-group'>
                      <input
                        type={showNewPassword ? 'text' : 'password'}
                        className='form-control form-control-lg form-control-solid'
                        placeholder='New Password'
                        {...formik.getFieldProps('password')}
                      />
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        {showNewPassword ? 'Hide' : 'Show'}
                      </button>
                    </div>
                    {formik.touched.password && formik.errors.password && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.password}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Confirm Password</label>
                  <div className='col-lg-8 fv-row'>
                    <div className='input-group'>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Confirm Password'
                        {...formik.getFieldProps('confirm_password')}
                      />
                      <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? 'Hide' : 'Show'}
                      </button>
                    </div>
                    {formik.touched.confirm_password && formik.errors.confirm_password && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.confirm_password}</div>
                      </div>
                    )}
                  </div>
                </div> */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Appointment Rate
                    {getSettingValue('currency_symbol') ? ` (${getSettingValue('currency_symbol')})` : ''}
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <input
                      type='number'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Appointment Rate'
                      {...formik.getFieldProps('appointment_rate')}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.appointment_rate && formik.errors.appointment_rate && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.appointment_rate}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span>Availale Platforms</span>
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      {...formik.getFieldProps('people_platforms')}
                      isMulti
                      placeholder="Select platforms... "
                      options={platforms?.map((platform) => ({
                        value: platform.id,
                        label: platform.platform_name,
                      }))}
                      className="basic-multi-select form-select-lg p-2 bg-light text-black"
                      classNamePrefix="select border-light fw-bold"
                      onChange={(selectedOptions) => {
                        formik.setFieldValue('people_platforms', selectedOptions);
                      }}
                    />
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span>Available Locations</span>
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      {...formik.getFieldProps('people_locations')}
                      isMulti
                      placeholder="Select Locations... "
                      options={locations?.map((location) => ({
                        value: location.id,
                        label: location.platform_name,
                      }))}
                      className="basic-multi-select form-select-lg p-2 bg-light text-black"
                      classNamePrefix="select border-light fw-bold"
                      onChange={(selectedOptions) => {
                        formik.setFieldValue('people_locations', selectedOptions);
                      }}
                    />
                  </div>
                </div>
              </>
            )}











            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span>Address Line 1</span>
              </label>
              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Address Line 1'
                  {...formik.getFieldProps('address')}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span>Address Line 2</span>
              </label>
              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Address Line 2'
                  {...formik.getFieldProps('address_line_2')}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Telephone</label>
              <div className='col-lg-8 fv-row'>
                <input
                  type='tel'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Telephone'
                  {...formik.getFieldProps('telephone')}
                  onChange={formik.handleChange}
                />
                {formik.touched.telephone && formik.errors.telephone && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.telephone}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Mobile number</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='tel'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Mobile number'
                  {...formik.getFieldProps('mobile')}
                />
                {formik.touched.mobile && formik.errors.mobile && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.mobile}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Picture</label>
              <div className='col-lg-8 fv-row'>
                <input
                  type='file'
                  className='form-control form-control-lg form-control-solid'
                  onChange={(e) => handleImageChange(
                    e,
                    'picture',
                    2, // Max file size (2MB)
                    ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                    {
                      picture: { width: 200, height: 200 }
                    } // Max dimensions
                  )}
                  accept="image/jpeg, image/jpg, image/png"
                  name='picture'
                />
                <div className='text-danger mt-2'>
                  Recommended size: 200 x 200 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
                </div>
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span>Status</span>
              </label>
              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg fw-bold'
                  {...formik.getFieldProps('status')}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            data-toggle='tooltip'
            data-placement='bottom'
            title='Add New User'
            type='button'
            className='btn btn-primary'
            disabled={loading}
            onClick={() => formik.handleSubmit()}
          >
            {!loading && 'Add User'}
          </button>
        </div>
      </div >
    </>
  )
}
export default AddUser;